/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Edit_TracksInputs */

const en_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing edit results for individual tracks.`)
};

const fr_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication des résultats d’édition pour les pistes individuelles.`)
};

const de_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsergebnisse für die einzelnen Titel.`)
};

const it_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione dei risultati delle modifiche per singole tracce.`)
};

const ru_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикация результатов редактирования для отдельных треков.`)
};

const es_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de resultados de edición para pistas individuales.`)
};

const zh_cn2_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布各个曲目的编辑结果。`)
};

const ja_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個々のトラックの編集結果を公開します。`)
};

const hi_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अलग-अलग ट्रैक के लिए संपादन परिणाम प्रकाशित करना।`)
};

const pt_pt2_work_order_publish_status_edit_tracks = /** @type {(inputs: Work_Order_Publish_Status_Edit_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicando os resultados da edição para cada faixa individual.`)
};

/**
* | output |
* | --- |
* | "Publishing edit results for individual tracks." |
*
* @param {Work_Order_Publish_Status_Edit_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_edit_tracks = /** @type {((inputs?: Work_Order_Publish_Status_Edit_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Edit_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_edit_tracks(inputs)
	if (locale === "de") return de_work_order_publish_status_edit_tracks(inputs)
	if (locale === "it") return it_work_order_publish_status_edit_tracks(inputs)
	if (locale === "ru") return ru_work_order_publish_status_edit_tracks(inputs)
	if (locale === "es") return es_work_order_publish_status_edit_tracks(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_edit_tracks(inputs)
	if (locale === "ja") return ja_work_order_publish_status_edit_tracks(inputs)
	if (locale === "hi") return hi_work_order_publish_status_edit_tracks(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_edit_tracks(inputs)
	return en_work_order_publish_status_edit_tracks(inputs)
});